export const queryKeys = {
  USER: 'App/user',
};
